import { STOREFRONT_CART_REDUCER } from '@/constants'
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { CartKey, CartState } from './types'

const initialState: CartState = {
  handle: '',
  cart: null,
}

const storeFrontCartSlice = createSlice({
  name: STOREFRONT_CART_REDUCER,
  initialState,
  reducers: {
    hydrate: (_s, a: PayloadAction<CartState>) => a.payload,
    addItem: (
      state,
      action: PayloadAction<{
        productId: string
        variantId: string
        quantity: number
      }>,
    ) => {
      const { productId, variantId, quantity } = action.payload
      const key: CartKey = `${productId}:${variantId}`
      if (state.cart[key]) {
        const { quantity: prevQty } = state.cart[key]
        state.cart[key].quantity = prevQty + quantity
      } else {
        state.cart[key] = action.payload
      }
    },
    setQuantity: (
      state,
      action: PayloadAction<{
        productId: string
        variantId: string
        quantity: number
      }>,
    ) => {
      const { productId, variantId } = action.payload
      state.cart[`${productId}:${variantId}`] = action.payload
    },
    removeItem: (
      state,
      action: PayloadAction<{
        productId: string
        variantId: string
      }>,
    ) => {
      const { productId, variantId } = action.payload
      delete state.cart[`${productId}:${variantId}`]
    },
    clearCart: (state) => {
      state.cart = {}
    },
  },
})

export const { hydrate, addItem, setQuantity, removeItem, clearCart } =
  storeFrontCartSlice.actions

export default storeFrontCartSlice.reducer
